module.exports = __webpack_public_path__ + "static/media/pickAFish.28634944.mp3";